var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { class: _vm.getClassName("alert") }, [
        _c("div", {
          class: _vm.getClassName("alert__overlay"),
          on: { click: _vm.hide }
        }),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("alert__wrapper") }, [
          _c(
            "div",
            {
              class: [
                "alert__content--" + _vm.varient,
                _vm.getClassName("alert__content")
              ]
            },
            [
              _vm._l(_vm.messages, function(message, index) {
                return _c(
                  "div",
                  { key: index, class: _vm.getClassName("alert__message") },
                  [_vm._v("\n        " + _vm._s(message) + "\n      ")]
                )
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: _vm.getClassName("alert__close"),
                  attrs: { type: "button" },
                  on: { click: _vm.hide }
                },
                [
                  _c("span", { class: _vm.getClassName("alert__cross") }),
                  _vm._v("\n        閉じる\n      ")
                ]
              )
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }